var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "41.000000pt",
    height: "41.000000pt",
    viewBox: "0 0 41.000000 41.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,41.000000) scale(0.100000,-0.100000)",
    fill: "#3B5158",
    stroke: "#3B5158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158 390 c-125 -39 -180 -172 -116 -281 90 -153 315 -110 353 69 8 41 -16 118 -50 155 -48 51 -129 76 -187 57z m127 -43 c110 -63 110 -221 0 -284 -143 -81 -303 79 -222 222 45 79 143 107 222 62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 223 l-67 -67 -26 24 c-39 36 -43 14 -5 -25 l34 -35 73 72 c65 65 87 98 65 98 -4 0 -37 -30 -74 -67z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2c327464598205b41035f66e36069903.svg";
export { ForwardRef as ReactComponent };